<script>
    import { onMount } from 'svelte';
    import BackgroundAnimation from './components/BackgroundAnimation.svelte';
    import Preloader from './components/Preloader.svelte';
    import Article from './components/Article.svelte';
    import CyberpunkTextStyler from './components/CyberpunkTextStyler.svelte';
  
    let articles = [
      { title: 'Cyberpunk News 1', content: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit.', image: 'https://picsum.photos/300/200?random=1' },
      { title: 'AI Breakthrough', content: 'Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.', image: 'https://picsum.photos/300/200?random=2' },
      { title: 'New Tech Gadget', content: 'Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris.', image: 'https://picsum.photos/300/200?random=3' },
      { title: 'Gaming Revolution', content: 'Duis aute irure dolor in reprehenderit in voluptate velit esse cillum.', image: 'https://picsum.photos/300/200?random=4' },
      { title: 'Entertainment News', content: 'Excepteur sint occaecat cupidatat non proident, sunt in culpa qui.', image: 'https://picsum.photos/300/200?random=5' },
      { title: 'Viral Meme', content: 'Officia deserunt mollit anim id est laborum.', image: 'https://picsum.photos/300/200?random=6' },
      { title: 'Cyberpunk Tool', content: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit.', image: 'https://picsum.photos/300/200?random=7' },
      { title: 'Future of AI', content: 'Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.', image: 'https://picsum.photos/300/200?random=8' },
      { title: 'Tech Trends', content: 'Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris.', image: 'https://picsum.photos/300/200?random=9' },
    ];
  
    let showPreloader = true;
    let currentSection = 'main';
  
    onMount(() => {
      setTimeout(() => {
        showPreloader = false;
      }, 2000);
    });
  
    function changeSection(section) {
      showPreloader = true;
      currentSection = section;
      setTimeout(() => {
        showPreloader = false;
      }, 1000);
    }
  
    function sendAnalytics(event) {
      // Replace with actual analytics service
      console.log('Analytics event:', event);
    }
  
    onMount(() => {
      sendAnalytics({ type: 'pageview', page: 'home' });
    });
</script>

<BackgroundAnimation />
{#if showPreloader}
  <Preloader />
{/if}

<main>
  <header>
    <div class="logo">CyberNews</div>
    <div class="ad-banner">Horizontal Ad Banner</div>
  </header>

  <nav>
    <ul>
      <li><a href="#main" on:click|preventDefault={() => changeSection('main')}>Main</a></li>
      <li><a href="#ai-news" on:click|preventDefault={() => changeSection('ai-news')}>AI News</a></li>
      <li><a href="#technologies" on:click|preventDefault={() => changeSection('technologies')}>Technologies</a></li>
      <li><a href="#gaming" on:click|preventDefault={() => changeSection('gaming')}>Gaming</a></li>
      <li><a href="#entertainment" on:click|preventDefault={() => changeSection('entertainment')}>Entertainment</a></li>
      <li><a href="#memes" on:click|preventDefault={() => changeSection('memes')}>Memes</a></li>
      <li><a href="#tools" on:click|preventDefault={() => changeSection('tools')}>Tools</a></li>
    </ul>
  </nav>

  <div class="content">
    <aside class="left-panel">
      <div class="ad-banner">Vertical Ad Banner 1</div>
      <div class="ad-banner">Vertical Ad Banner 2</div>
    </aside>

    <section class="articles">
      {#each articles as article}
        <Article {article} on:click={() => sendAnalytics({ type: 'article_click', title: article.title })} />
      {/each}
    </section>

    <aside class="right-panel">
      <div class="ad-banner">Vertical Ad Banner 3</div>
      <div class="ad-banner">Vertical Ad Banner 4</div>
    </aside>
  </div>

  <div class="tools">
    <h2>Cyberpunk Text Styler</h2>
    <CyberpunkTextStyler on:use={() => sendAnalytics({ type: 'tool_use', tool: 'Cyberpunk Text Styler' })} />
  </div>

  <footer>
    <div class="about">About CyberNews</div>
    <div class="idea">Our Vision</div>
  </footer>
</main>

<style>
  :global(body) {
    margin: 0;
    padding: 0;
    font-family: 'Courier New', monospace;
    background-color: #0a0a0a;
    color: #00ff00;
    overflow-x: hidden;
  }

  main {
    max-width: 1200px;
    margin: 0 auto;
    padding: 20px;
    position: relative;
    z-index: 1;
  }

  header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 20px;
  }

  .logo {
    font-size: 24px;
    font-weight: bold;
    color: #00ffff;
  }

  nav ul {
    list-style-type: none;
    padding: 0;
    display: flex;
    justify-content: space-around;
    background-color: #1a1a1a;
    padding: 10px 0;
  }

  nav ul li a {
    color: #ff00ff;
    text-decoration: none;
    padding: 5px 10px;
    border: 1px solid #ff00ff;
    border-radius: 5px;
    transition: all 0.3s ease;
  }

  nav ul li a:hover {
    background-color: #ff00ff;
    color: #1a1a1a;
  }

  .content {
    display: flex;
    justify-content: space-between;
  }

  .articles {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    width: 60%;
  }

  aside {
    width: 18%;
  }

  .ad-banner {
    background-color: #1a1a1a;
    border: 1px solid #ff00ff;
    height: 300px;
    margin-bottom: 20px;
    display: flex;
    justify-content: center;
    align-items: center;
    color: #ff00ff;
  }

  .tools {
    margin-top: 20px;
    padding: 20px;
    background-color: #1a1a1a;
    border: 1px solid #00ffff;
  }

  footer {
    margin-top: 20px;
    text-align: center;
    padding: 10px;
    background-color: #1a1a1a;
    color: #00ffff;
  }

  @media (max-width: 768px) {
    .content {
      flex-direction: column;
    }

    .articles {
      width: 100%;
    }

    aside {
      width: 100%;
      margin-top: 20px;
    }
  }
</style>